.badge {
  display: inline-block;
  padding: 1px var(--spacing-sm);
  border-radius: 999px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  line-height: 1.5;
  white-space: nowrap;
}

.neutral {
  background: var(--color-surface-hover);
  color: var(--color-text-muted);
}

.primary {
  background: var(--color-primary-soft);
  color: var(--color-primary);
}

.warning {
  background: var(--color-warning-soft);
  color: var(--color-warning);
}
